import React, { Component, useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  Button,
  Drawer,
} from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
// import IconButton from '@material-ui/core/IconButton';
// import Typography from '@material-ui/core/Typography';
import RootRef from "@material-ui/core/RootRef";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragIndicatorRoundedIcon from "@material-ui/icons/DragIndicatorRounded";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import { withStyles } from "@material-ui/core/styles";
import ArrowDown from "@material-ui/icons/ArrowDropDown";
import Add from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import SectionIcon from "@material-ui/icons/AllInclusive";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import TextField from "@material-ui/core/TextField";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import Divider from "@material-ui/core/Divider";
import "../../index.css";
import "./template.css";
import refresh_token from "./../../Global/refresh_token";
import swal from "@sweetalert/with-react";
import { useSelector, useDispatch } from "react-redux";
import GlobalApi from "./../../Global";
import ManageResponse from "./ManageResponse";
import EditIcon from "@material-ui/icons/Edit";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowOpen from "@material-ui/icons/ArrowDropDownCircle";
import ArrowClose from "@material-ui/icons/PlayCircleFilled";
import Checkbox from "@material-ui/core/Checkbox";
import Colors from "./../../Global/colors";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import DarkButton from "./../../Global/DarkButton";
import LightButton from "./../../Global/LightButton";

//images
import info from "../../Assets/info.png";
import text from "../../Assets/text.png";
import number from "../../Assets/number.png";
import picture from "../../Assets/picture.png";
import annotation from "../../Assets/annotation.png";
import date from "../../Assets/date.png";
import location from "../../Assets/location.png";
import checkbox from "../../Assets/checkbox.png";
import signature from "../../Assets/signature.png";
// a little function to help us with reordering the result
import { useTranslation } from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";

import CheckComponent from "./CheckComponent";

import { Map } from "immutable";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const grid = 8;

const useStyles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  optionStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  optionStyleFull: {
    // display: "flex",
    // flexDirection: "row",
    // justifyContent: "space-between",
    // position: "absolute",
    // top: 0,
    // left: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: "100vw",
    height: "100vh",
  },
  selectStyle: {
    backgroundColor: "#f5f5f5",
  },
  positionSetting: {
    //meginLeft:-500
  },
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  itemStyle: {
    // border: "2px solid",
    // borderColor: "#e9f8ff",
    padding: "2px 5px",
    marginBottom: 0,
    backgroundColor: "white",
  },
  controlStyle: {
    width: "100%",
    // border: "2px solid",
    // borderColor: "#e9f8ff",
    marginBottom: 5,
    backgroundColor: "white",
    // marginLeft: -3,
  },
  selectedStyle: {
    border: "2px  solid",
    //borderColor:'#26a69a',
    borderColor: "#043077",
    // height: 128, //56,
    marginBottom: 0,
  },
  unselectedStyle: {},
  show: {},
  hide: {
    display: "none",
  },
  textBoxStyle: {
    fontWeight: "bold",
    paddingLeft: theme.spacing.unit,
  },
  conditionalControlStyle: {
    width: "100%",
    // marginBottom: 5,
    backgroundColor: "white",
    overflow: "auto",
    // marginLeft: -3,
  },
  itemRuleStyle: {
    borderTop: "1px solid",
    borderColor: "#dadada",
    marginBottom: 0,
    paddingLeft: "20px",
    paddingRight: "10px",
  },
  typoStyle: {
    fontSize: 13,
    color: "gray",
    fontFamily: "ProductSans",
  },
  itemConfigureStyle: {
    border: "2px solid",
    borderColor: "#c6d8e0",
    marginBottom: 0,
    marginTop: -10,
    //backgroundColor:'#fafafa',
    width: "100%",
    display: "flex",
    flexDirection: "row",
  },
  configurationContainerStyle: {
    padding: 10,
    display: "flex",
    flexDirection: "row",
  },
});
const randomColor = () =>
  ("#" + ((Math.random() * 0xffffff) << 0).toString(16) + "000000").slice(0, 7);

const useStylesComponents = makeStyles((theme) => ({
  response1Style: {
    //marginRight:5,
    //marginBottom:5,
  },
  root: {
    // display: "flex",
    // flexDirection: "row",
    // justifyContent: "space-between",
    width: "100%",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    //justifyContent:'space-between',
    width: "100%",
    overflow: "auto",
    borderLeft: "1px solid #C2C5CC",
    // height: "80%"
  },
  container2: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 2,
    width: "100%",
  },
  containerResponses: {
    display: "flex",
    flexDirection: "column",
    height: "90%",
    overflow: "auto",
    width: "100%",
  },
  headingContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
    padding: 10,
  },
  cardColorStyle1: {
    //backgroundColor:'#FDD835',
    borderBottom: "1px solid #C2C5CC",
    borderLeft: "1px solid #C2C5CC",
    width: "100%",
  },
  cardColorStyle2: {
    //backgroundColor:'#F0F4C3',
    borderBottom: "1px solid #C2C5CC",
    borderLeft: "1px solid #C2C5CC",
  },
  cardColorStyle3: {
    //backgroundColor:'#4594b8'
    borderBottom: "1px solid #C2C5CC",
    borderLeft: "1px solid #C2C5CC",
  },
  itemStyle: {
    borderRadius: 10,
    backgroundColor: "#eaf7fe",
    // borderWidth:'thin',
    // border:'1px solid',
    marginRight: 5,
    padding: 5,
    alignSelf: "center",
  },
  textStyle: {
    fontSize: 12,
    color: "black",
  },
  responseContainer: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 5,
    padding: 10,
  },
  displayControlStyle: {
    padding: 10,
  },
  menuContainer: {
    width: 60,
    borderRadius: 10,
    //backgroundColor:'lightgray',
    backgroundColor: "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    zIndex: 100,
    top: 0,
    left: -80,
    position: "absolute",
    border: "1px solid",
    borderColor: "lightgray",
    justifyContent: "center",
    borderRadius: 5,
  },
  arrowContainer: {
    width: 30,
    zIndex: 100,
    top: 10,
    left: 50,
    position: "absolute",
  },
  hide: {
    display: "none",
  },
  optionContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 5,
  },
  optionItemStyle: {
    textAlign: "center",
    fontSize: 14,
    marginTop: -10,
  },
  formControl: {
    marginLeft: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    //marginTop: -theme.spacing(0.5),
  },
  Icon: {
    width: 30,
    alignSelf: "center",
    cursor: "pointer",
  },
  blankContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 10,
  },
  showConditionalTextBox: {
    marginLeft: 5,
    // marginTop: -22,
  },
  textBoxStyle: {
    //marginLeft:-theme.spacing.unit*12,
    paddingLeft: theme.spacing.unit,
    height: 30,
  },
  divTypoStyle: {
    width: "100%",
    //justifyContent:'center'
  },
}));

const getItemStyle = (isDragging, draggableStyle) => ({
  // styles we need to apply on draggables
  ...draggableStyle,

  ...(isDragging && {
    //background: "rgb(235,235,235)",
    background: "#fafafa",
    height: 50, //80 //50
  }),
});

const getListStyle = (isDraggingOver) => ({
  //background: isDraggingOver ? "lightblue" : "white",
  //padding: grid,
});

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const DisplayControl = (props) => {
  var icon = "";
  var color = "";
  const classes = useStylesComponents();
  if (props.selectedControl == "Checkbox") {
    icon = checkbox;
    color = "orange";
  }

  if (props.selectedControl == "Text field") {
    icon = text;
    color = "red";
  }

  if (props.selectedControl == "Number") {
    icon = number;
    color = "#043077";
  }

  if (props.selectedControl == "DateTime") {
    icon = date;
    color = "green";
  }

  if (props.selectedControl == "Photo") {
    icon = picture;
    color = "#00CED1";
  }

  if (props.selectedControl == "Anotation") {
    icon = annotation;
    color = "maroon";
  }

  if (props.selectedControl == "Signature") {
    icon = signature;
    color = "blue";
  }

  if (props.selectedControl == "Location") {
    icon = location;
    color = "#E75480";
  }

  if (props.selectedControl == "Instruction") {
    icon = info;
    color = "#FF00FF";
  }
  return props.selectedControl != "Custom" ? (
    <div
      className="shadow"
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: Colors.globalColor9,
        borderRadius: 15,
        padding: "5px 10px",
        marginTop: 7,
      }}
    >
      <img src={icon} width="12" /> &nbsp;
      <p class="innerBox" style={{ display: "inline" }}>
        {props.selectedControl}
      </p>
    </div>
  ) : (
    <div className={classes.responseContainer}>
      {props.responseLibrary?.responses.map((response) => {
        return (
          <div
            className={classes.itemStyle}
            style={{
              boxShadow:
                "0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19",
              borderRadius: "30px",
            }}
          >
            <span className={classes.textStyle}>{response.title}</span>
          </div>
        );
      })}
    </div>
  );
};

const MobileOptions = (props) => {
  const classes = useStylesComponents();
  const handleClick = (actionType) => {
    props.addNewQuestion(
      props.checkListItemId,
      props.templateId,
      props.controlIndex,
      actionType,
      props.componentType
    );
  };
  return (
    <Grid
      container
      className={props.controlIndex == props.dragIndex ? null : classes.hide}
      style={{ padding: 5, zIndex: 10 }}
    >
      <Grid item xs={6} style={{ padding: 3 }}>
        <LightButton
          fullWidth
          onClick={() => {
            handleClick("new");
          }}
        >
          <Add
          // style={{ width: 30, height: 30, marginTop: 0, color: "#043077" }}
          />
          Question
        </LightButton>
      </Grid>

      <Grid
        item
        xs={6}
        className={
          props.dataType == "DateTime" ||
          props.dataType == "Photo" ||
          props.dataType == "Instruction" ||
          props.dataType == "Anotation" ||
          props.dataType == "Location" ||
          props.componentType == "conditional"
            ? classes.hide
            : null
        }
        style={{ padding: 3 }}
      >
        <LightButton
          fullWidth
          onClick={() => {
            handleClick("logical");
          }}
        >
          <SectionIcon
          // style={{ width: 30, height: 30, marginTop: 0, color: "orange" }}
          />
          Logic
        </LightButton>
      </Grid>
    </Grid>
  );
};

const ContitionalResponse = (props) => {
  const { t } = useTranslation();
  const [parent, setParent] = useState(props.parentId);
  const [permissions_obj, setPermissionObj] = useState({});
  let userData = useSelector((state) => state.userReducer.user);
  let company = useSelector((state) => state.companyReducer.company);
  //const [parent, setParent] = useState(props.props.cselectedParentId);
  const closePopup = (controlType, controlID) => {
    //alert(controlType +" --- "+ controlID +"----"+parent)
    //alert(props.props.cselectedParentId)
    props.close(
      controlType,
      controlID,
      "",
      -1,
      props.props.cselectedParentId,
      props.props.sselectedParentId
    );
  };

  const getPermissions = () => {
    console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company?.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log(response);
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v?.title)] = true;
            });
            console.log("Permissions Obj >>>>>>>", permissionsObj);

            setPermissionObj(permissionsObj);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", error.message);
        });
    }
  };

  const closeResponsePopup = (controlType, controlID, responseGroupId) => {
    props.close(
      controlType,
      controlID,
      responseGroupId,
      props.DragIndex,
      parent
    );
  };
  const [global, setGlobalLibary] = useState(() => {
    var responseLibrary = [...props.responseLibrary];
    var list = responseLibrary.filter((x) => x.identifier == "Global");
    return list;
  });
  const [custom, setCustomLibary] = useState(() => {
    var responseLibrary = [...props.responseLibrary];
    var list = responseLibrary.filter((x) => x.identifier == "Custom");
    return list;
  });
  const clickResponse = () => {
    props.openResponse(true, "new");
  };
  const onEdit = (id) => {
    props.setReponseInfo("edit", id);
  };

  const onDelete = (resId) => {
    console.log("RESID______________________________", resId);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      response_id: resId,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Response/delete_response?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then((response) => {
        console.log("response________________", response);
        if (response.msg == "success") {
          swal(t("Success"), t("Response has been Deleted"), "success");
          props.refreshResponse();
          //  fetchResponse()
        } else {
          swal(t("Warning"), response.error, "error");
        }
      })
      .catch((error) => console.log("error", error));
  };

  const classes = useStylesComponents();
  return (
    <Grid
      container
      className="selectBox"
      style={{ overflow: "hidden", maxWidth: "330px" }}
    >
      <Accordion style={{ width: "100%" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <p className="accordianTitle">Basic Fields</p>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <MenuItem
                style={{
                  padding: "5px",
                  border: "1px dashed #043077",
                  borderRadius: "5px",
                }}
                value="Text field"
                onClick={() => {
                  closePopup("Text field", props.item);
                }}
              >
                <img src={text} width="14" /> &emsp;{" "}
                <p class="innerBox">Text</p>
              </MenuItem>
            </Grid>
            <Grid item xs={6}>
              <MenuItem
                style={{
                  padding: "5px",
                  border: "1px dashed #043077",
                  borderRadius: "5px",
                }}
                value="Number"
                onClick={() => {
                  closePopup("Number", props.item);
                }}
              >
                <img src={number} width="14" /> &emsp;{" "}
                <p class="innerBox">Number</p>
              </MenuItem>
            </Grid>

            <Grid item xs={6}>
              <MenuItem
                style={{
                  padding: "5px",
                  border: "1px dashed #043077",
                  borderRadius: "5px",
                }}
                value="Checkbox"
                onClick={() => {
                  closePopup("Checkbox", props.item);
                }}
              >
                <img src={checkbox} width="14" /> &emsp;
                <p class="innerBox">Checkbox</p>
              </MenuItem>
            </Grid>
            <Grid item xs={6}>
              <MenuItem
                style={{
                  padding: "5px",
                  border: "1px dashed #043077",
                  borderRadius: "5px",
                }}
                value="DateTime"
                onClick={() => {
                  closePopup("DateTime", props.item);
                }}
              >
                <img src={date} width="14" /> &emsp;
                <p class="innerBox">Date/Time</p>
              </MenuItem>
            </Grid>
            <Grid item xs={6}>
              <MenuItem
                style={{
                  padding: "5px",
                  border: "1px dashed #043077",
                  borderRadius: "5px",
                }}
                value="Photo"
                onClick={() => {
                  closePopup("Photo", props.item);
                }}
              >
                <img src={picture} width="14" /> &emsp;
                <p class="innerBox">Image</p>
              </MenuItem>
            </Grid>
            <Grid item xs={6}>
              <MenuItem
                style={{
                  padding: "5px",
                  border: "1px dashed #043077",
                  borderRadius: "5px",
                }}
                value="Anotation"
                onClick={() => {
                  closePopup("Anotation", props.item);
                }}
              >
                <img src={annotation} width="14" /> &emsp;
                <p class="innerBox">Annotation</p>
              </MenuItem>
            </Grid>
            <Grid item xs={6}>
              <MenuItem
                style={{
                  padding: "5px",
                  border: "1px dashed #043077",
                  borderRadius: "5px",
                }}
                value="Signature"
                onClick={() => {
                  closePopup("Signature", props.item);
                }}
              >
                <img src={signature} width="14" /> &emsp;
                <p class="innerBox">Signature</p>
              </MenuItem>
            </Grid>
            <Grid item xs={6}>
              <MenuItem
                style={{
                  padding: "5px",
                  border: "1px dashed #043077",
                  borderRadius: "5px",
                }}
                value="Location"
                onClick={() => {
                  closePopup("Location", props.item);
                }}
              >
                <img src={location} width="14" /> &emsp;
                <p class="innerBox">Location</p>
              </MenuItem>
            </Grid>

            <Grid item xs={6}>
              <MenuItem
                style={{
                  padding: "5px",
                  border: "1px dashed #043077",
                  borderRadius: "5px",
                }}
                value="Instruction"
                onClick={() => {
                  closePopup("Instruction", props.item);
                }}
              >
                <img src={info} width="14" /> &emsp;
                <p class="innerBox">Instruction</p>
              </MenuItem>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Accordion style={{ width: "100%" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          style={{ justifyContent: "space-between" }}
        >
          <p className="accordianTitle">Multiple Choice Responses</p>

          {userData?.super_admin == true ||
          permissions_obj["Admin"] == true ||
          permissions_obj["Manage Response Sets"] == true ? (
            <Button
              size="small"
              className="startInspectionBtnSmall"
              style={{
                backgroundColor: Colors.globalColor8,
                marginLeft: "5px",
              }}
              onClick={clickResponse}
            >
              + Response
            </Button>
          ) : (
            <Button
              size="small"
              className="startInspectionBtnSmall2"
              disabled
              style={{ backgroundColor: "grey", marginLeft: "5px" }}
            >
              + Response
            </Button>
          )}
        </AccordionSummary>
        <AccordionDetails>
          <div
            className="scrollbarShow2"
            style={{ height: "100px", overflowY: "auto" }}
          >
            {custom.map((group) => {
              return (
                <div className={classes.container2} style={{ width: "100%" }}>
                  <MenuItem
                    value="Checkbox"
                    className={classes.container2}
                    onClick={() => {
                      closeResponsePopup("Custom", props.item, group.id);
                    }}
                    style={{ overflow: "hidden" }}
                  >
                    {group.responses.map((item) => {
                      return (
                        <div
                          className="shadow"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: Colors.globalColor9,
                            borderRadius: 15,
                            padding: "5px 10px",
                          }}
                        >
                          <p class="innerBox" style={{ display: "inline" }}>
                            {item.title}
                          </p>
                        </div>
                      );
                      // <div className={classes.itemStyle}>
                      //   <span className={classes.textStyle}>{item.title}</span>
                      // </div>
                    })}
                  </MenuItem>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginLeft: "10px",
                    }}
                  >
                    {userData?.super_admin == true ||
                    permissions_obj["Admin"] == true ||
                    permissions_obj["Manage Response Sets"] == true ? (
                      <ListItemIcon
                        style={{ cursor: "pointer", minWidth: "0" }}
                        onClick={() => {
                          onEdit(group.id);
                        }}
                      >
                        <EditIcon
                          style={{
                            color: Colors.globalColor8,
                            fontSize: "18px",
                          }}
                        />
                      </ListItemIcon>
                    ) : (
                      <ListItemIcon
                        style={{ cursor: "pointer", minWidth: "0" }}
                      >
                        <EditIcon
                          style={{ color: "#dadada", fontSize: "18px" }}
                        />
                      </ListItemIcon>
                    )}

                    {userData?.super_admin == true ||
                    permissions_obj["Admin"] == true ||
                    permissions_obj["Manage Response Sets"] == true ? (
                      <ListItemIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          onDelete(group.id);
                        }}
                      >
                        <DeleteIcon
                          style={{
                            color: Colors.globalColor8,
                            fontSize: "18px",
                          }}
                        />
                      </ListItemIcon>
                    ) : (
                      <ListItemIcon style={{ cursor: "pointer" }}>
                        <DeleteIcon
                          style={{ color: "#dadada", fontSize: "18px" }}
                        />
                      </ListItemIcon>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion style={{ width: "100%" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          {" "}
          <p className="accordianTitle">Global Responses</p>
        </AccordionSummary>
        <AccordionDetails>
          <div
            className="scrollbarShow2"
            style={{ height: "100px", overflowY: "auto", width: "100%" }}
          >
            {global.map((group) => {
              return (
                <div className={classes.container2}>
                  <MenuItem
                    value="Checkbox"
                    className={classes.container2}
                    onClick={() => {
                      closeResponsePopup("Custom", props.item, group.id);
                    }}
                    style={{ overflow: "auto" }}
                  >
                    <div
                      className="shadow"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: Colors.globalColor9,
                        borderRadius: 15,
                        padding: "5px 10px",
                        boxShadow:
                          "0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19",
                      }}
                    >
                      <p class="innerBox" style={{ display: "inline" }}>
                        {group.title}
                      </p>
                    </div>
                    {/* {
              
                    <div className={classes.itemStyle}>
                      <span className={classes.textStyle}>{group.title}</span>
                    </div>
                   
                  } */}
                  </MenuItem>
                </div>
              );
            })}
          </div>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

const Logic = (props) => {
  const { t } = useTranslation();
  const classes = useStylesComponents();
  const [editTitle, setTitle] = React.useState(false);
  //const[checklist,setChecklist]=React.useState([])
  const [selectedOption, setOption] = React.useState(
    props.parent.condition != "" ? props.parent.condition : ""
  );
  const [dataType, setDataType] = React.useState("");
  const [optionList, setOptions] = React.useState([]);
  const [value, setValue] = React.useState(
    props.parent.conditionValue != "" ? props.parent.conditionValue : ""
  );
  React.useEffect(() => {
    if (props.dataType == dataType) return;

    setDataType(props.dataType);
    if (props.dataType == "Text field") {
      var options = [{ id: 1, title: "is" }, { id: 2, title: "is not" }];
      setOptions(options);
      var indx = options.findIndex((x) => x.title == props.parent.condition);
      if (indx != -1) {
        setOption(props.parent.condition);
        props.setCondition(
          props.parent.id,
          props.parent.condition,
          props.parent.conditionValue,
          props.itemIndex
        );
      } else {
        setOption("is");
        setValue("");
        props.setCondition(props.parent.id, "is", "", props.itemIndex);
      }
    }
    if (props.dataType == "Number" || props.dataType == "Slider") {
      var options = [
        { id: 1, title: "less than" },
        { id: 2, title: "less than or equal to" },
        { id: 3, title: "equal to" },
        { id: 4, title: "not equal to" },
        { id: 5, title: "greater than or equal to" },
        { id: 6, title: "greater than" },
        { id: 7, title: "is between" },
        { id: 8, title: "is not between" },
      ];
      setOptions(options);
      //setOption('less than')
      //props.setCondition(props.parent.id,"less than","",props.itemIndex)
      var indx = options.findIndex((x) => x.title == props.parent.condition);
      if (indx != -1) {
        setOption(props.parent.condition);
        props.setCondition(
          props.parent.id,
          props.parent.condition,
          props.parent.conditionValue,
          props.itemIndex
        );
      } else {
        setOption("less than");
        setValue("");
        props.setCondition(props.parent.id, "less than", "", props.itemIndex);
      }
    }
    if (props.dataType == "Signature") {
      var options = [
        { id: 1, title: "name is" },
        { id: 2, title: "name is not" },
        { id: 3, title: "exists" },
        { id: 4, title: "does not exist" },
      ];
      setOptions(options);
      var indx = options.findIndex((x) => x.title == props.parent.condition);
      if (indx != -1) {
        setOption(props.parent.condition);
        props.setCondition(
          props.parent.id,
          props.parent.condition,
          props.parent.conditionValue,
          props.itemIndex
        );
      } else {
        setOption("name is");
        setValue("");
        props.setCondition(props.parent.id, "name is", "", props.itemIndex);
      }
    }
    if (props.dataType == "Checkbox") {
      var options = [
        { id: 1, title: "checked" },
        { id: 2, title: "not checked" },
      ];
      setOptions(options);
      //setOption('checked')
      //props.setCondition(props.parent.id,"is","checked",props.itemIndex)
      var indx = options.findIndex(
        (x) => x.title == props.parent.conditionValue
      );
      if (indx != -1) {
        setOption(props.parent.conditionValue);
        props.setCondition(
          props.parent.id,
          "is equal to",
          props.parent.conditionValue,
          props.itemIndex
        );
      } else {
        setOption("checked");
        props.setCondition(
          props.parent.id,
          "is equal to",
          "checked",
          props.itemIndex
        );
      }
    }
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const setChoice = (choice) => {
    setOption(choice);
    setAnchorEl(null);
    if (props.dataType == "Checkbox")
      props.setCondition(props.parent.id, "is", choice, props.itemIndex);
    else props.setCondition(props.parent.id, choice, value, props.itemIndex);
  };
  const open = Boolean(anchorEl);
  const Options = (props) => {
    const [list, setList] = React.useState(props.options);
    return (
      <div style={{ maxHeight: 400, width: "100%", overflow: "auto" }}>
        {list.map((option) => {
          return (
            <div>
              <MenuItem
                onClick={() => {
                  props.setChoice(option.title);
                }}
                className={classes.optionItemStyle}
                style={{ padding: 10 }}
              >
                {option.title}
              </MenuItem>
            </div>
          );
        })}
      </div>
    );
  };
  const onEdit = (state) => {
    setTitle(state);
  };
  const onDelete = (resId) => {
    console.log("RESID______________________________", resId);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      response_id: resId,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Response/delete_response?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then((response) => {
        console.log("response________________", response);
        if (response.msg == "success") {
          swal(t("Success"), t("Response has been Deleted"), "success");
          props.refreshResponse();
          //  fetchResponse()
        } else {
          swal(t("Warning"), response.error, "error");
        }
      })
      .catch((error) => console.log("error", error));
  };

  const handleClickAway = () => {
    setTitle(false);
  };
  const handleTextChange = (event) => {
    setValue(event.target.value);
    props.setCondition(
      props.parent.id,
      selectedOption,
      event.target.value,
      props.itemIndex
    );
  };
  const handleSelection = (id, label) => {
    setValue(label);
    setOption("is");
    props.setCondition(props.parent.id, "is", label, props.itemIndex);
    //alert(label)
    //alert(JSON.stringify(event.target))
  };
  const renderValue = (value) => {
    return value;
  };
  return (
    <div className="conditionalStatement">
      <Popover
        id={open ? "simple-popover" : undefined}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "center", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
        elevation={5}
      >
        <Options options={optionList} setChoice={setChoice} />
      </Popover>
      <ClickAwayListener onClickAway={handleClickAway}>
        <FormControl
          variant="outlined"
          size="small"
          style={{ verticalAlign: "center" }}
        >
          <div
            className={
              editTitle &&
              (dataType == "Text field" ||
                dataType == "Number" ||
                dataType == "Slider" ||
                dataType == "Signature")
                ? classes.showConditionalTextBox
                : classes.hide
            }
          >
            <div style={{ marginRight: 5, display: "flex" }}>
              <div>
                <div
                  style={{
                    color: Colors.globalColor8,
                    marginRight: 5,
                    marginTop: 5,
                    cursor: "pointer",
                  }}
                  onClick={handleClick}
                >
                  {selectedOption}
                </div>
              </div>
              <div>
                <TextField
                  className={[
                    "customField",
                    { className: classes.textBoxStyle },
                  ]}
                  InputProps={{
                    className: classes.textBoxStyle,
                  }}
                  onChange={(e) => {
                    handleTextChange(e);
                  }}
                  value={value}
                  variant="outlined"
                />
              </div>
            </div>
          </div>

          <div
            className={
              (dataType == "Text field" ||
                dataType == "Number" ||
                dataType == "Slider" ||
                dataType == "Signature") &&
              !editTitle
                ? classes.blankContainer
                : classes.hide
            }
          >
            <span
              style={{
                color: Colors.globalColor8,
                marginLeft: 0,
                marginRight: 5,
                cursor: "pointer",
              }}
              onClick={handleClick}
            >
              {selectedOption}
            </span>

            <div style={{ marginRight: 5 }}>
              {value == "" ? "Blank" : value}
            </div>
            <div
              className={
                (dataType == "Text field" ||
                  dataType == "Number" ||
                  dataType == "Signature" ||
                  dataType == "Slider") &&
                !editTitle
                  ? classes.Icon
                  : classes.hide
              }
            >
              <Tooltip title="Edit Title">
                <ListItemIcon
                  onClick={() => {
                    onEdit(true);
                  }}
                >
                  <EditIcon
                    style={{ color: Colors.globalColor8, fontSize: "16px" }}
                  />
                </ListItemIcon>
              </Tooltip>
            </div>
          </div>

          <div
            className={
              dataType == "Checkbox" ? classes.blankContainer : classes.hide
            }
          >
            <span
              style={{
                color: "blue",
                marginLeft: 20,
                marginRight: 5,
                cursor: "pointer",
              }}
              onClick={handleClick}
            >
              {selectedOption}
            </span>
          </div>

          <Select
            style={{ marginLeft: 5 }}
            value={value}
            renderValue={() => renderValue(value)}
            //onChange={handleSelection}
            //displayEmpty
            className={
              props.dataType == "Custom" || props.dataType == "Global"
                ? classes.selectEmpty
                : classes.hide
            }
          >
            {props.dataType == "Custom" || props.dataType == "Global" ? (
              props.responseLibrary.responses.map((res) => {
                return (
                  <MenuItem
                    onClick={() => {
                      handleSelection(res.id, res.title);
                    }}
                    value={res.id}
                  >
                    {res.title}
                  </MenuItem>
                );
              })
            ) : (
              <div />
            )}
          </Select>
        </FormControl>
      </ClickAwayListener>
    </div>
  );
};

class drag extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      title: "some title",
      id: 1,
      DataType: "Text Field",
      isShow: true,
      items: props.checklist.list != undefined ? props.checklist.list : [], //getItems(3)
      template:
        props.checklist.template != undefined ? props.checklist.template : [],
      section: props.section != undefined ? props.section : [],
      anchorEl: null,
      open: false,
      selectedItemId: -1,
      responseLibrary: props.responseLibrary,
      selectedDragElementIndex: -1,
      responseAction: false,
      action: "New",
      responseId: -1,
      cselectedParentId: -1,
      sselectedParentId: -1,
    };

    console.log("new Props", props);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onDragEnd2 = this.onDragEnd2.bind(this);
    //alert(JSON.stringify(props.HOCprops.HOCprops.templateId))
  }

  handleClickAway = () => {
    this.setState({
      selectedDragElementIndex: -1,
      conditionalElementIndex: -1,
      subElementIndex: -1,
    });
  };
  handleClick = (event, item) => {
    this.setState({
      anchorEl: event.currentTarget,
      open: true,
      selectedItemId: item,
    });
  };

  handleClose = async (index) => {
    // console.log("SHOULD WROK");
    await this.setState({ anchorEl: null, open: false, selectedItemId: -1 });
    await this.setState({ selectedDragElementIndex: index });
  };

  onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.props.checklist.list,
      result.source.index,
      result.destination.index
    );

    this.setState({
      items,
      selectedDragElementIndex: result.destination.index,
    });
    this.props.onUpdateChecklist(
      items,
      this.state.template,
      result.source.index,
      result.destination.index,
      "Change List Position"
    );
  }
  handleChange = async (val, id, responseGroupId, dragIndex, section) => {
    console.log("CHECK !@#", val);
    if (val == "Custom") {
      var list = await [...this.props.checklist.list];
      var indx = await list.findIndex((x) => x.id == id);
      if (indx != -1) {
        var responseLibrary = await this.props.responseLibrary.find(
          (y) => y.id == responseGroupId
        );
        list[indx].dataType = await val;
        list[indx].responseLibrary = await responseLibrary;
        if (list[indx].conditional == "yes") {
          //list[indx].conditionalList=[]
          list[indx].conditionalList.map((item) => {
            item.status = "deleted";
          });
        }
        list[indx].multiselection = false;
        list[indx].conditional = "no";
        list[indx].isopen = "no";
        await this.props.onUpdateChecklist(
          list,
          this.state.template,
          this.state.section.id,
          indx,
          "Change List Option"
        );
        await this.setState({
          items: list,
          anchorEl: null,
          open: false,
          selectedDragElementIndex: dragIndex,
        });
      }
    } else {
      var list = await [...this.props.checklist.list];
      var indx = await list.findIndex((x) => x.id == id);

      if (indx != -1) {
        //alert('Here..')
        list[indx].dataType = await val;
        list[indx].responseLibrary = [];
        if (list[indx].conditional == "yes") {
          //list[indx].conditionalList=[]
          list[indx].conditionalList.map((item) => {
            item.status = "deleted";
          });
        }
        list[indx].multiselection = false;
        list[indx].conditional = "no";
        list[indx].isopen = "no";
        await this.props.onUpdateChecklist(
          list,
          this.state.template,
          this.state.section.id,
          indx,
          "Change List Option"
        );
        await this.setState({ items: list, anchorEl: null, open: false });
      }
    }
  };
  handleTextChange = (event, item) => {
    // alert(item)
    var list = [...this.props.checklist.list];
    var indx = list.findIndex((x) => x.id == item);
    if (indx != -1) {
      list[indx].title = event.target.value;
      this.props.onUpdateChecklist(
        list,
        this.state.template,
        event.target.value,
        indx,
        "Change Field Name"
      );
      this.setState({ items: list });
    }
  };
  addNewQuestion = (
    itemId,
    templateId,
    controlIndex,
    actionType,
    componentType
  ) => {
    if (componentType == "normal") {
      this.props.addNewQuestion(itemId, templateId, actionType);
      //this.setState({selectedDragElementIndex:controlIndex+1})
      this.setState({ selectedDragElementIndex: -1 });
    }
    if (componentType == "conditional") {
      this.props.addNewLogicalQuestion(
        itemId,
        templateId,
        this.state.template.id,
        actionType
      );
      //this.setState({conditionalElementIndex:controlIndex+1})
      this.setState({ conditionalElementIndex: -1 });
    }
  };
  clickResponse = (state) => {
    this.setState({
      responseAction: state,
      action: "New",
    });
  };
  refreshResponse = async () => {
    await this.props.getResponseLibrary();
    this.setState({
      anchorEl: null,
      open: false,
      selectedItemId: -1,
      copen: false,
      sopen: false,
    });
    //this.setState({selectedDragElementIndex:index})
  };
  setReponseInfo = (action, id) => {
    this.setState({ responseId: id, action: action, responseAction: true });
  };
  handleConditionalClick = (event, item, index, parentId) => {
    //alert(parentId);
    this.setState({
      canchorEl: event.currentTarget,
      copen: true,
      cselectedItemId: item,
      cselectedParentId: parentId,
    });
  };
  handleConditionalClose = async (index) => {
    await this.setState({
      canchorEl: null,
      copen: false,
      cselectedItemId: -1,
      cselectedParentId: -1,
    });
    await this.setState({ conditionalElementIndex: index });
  };
  handleConditionalChange = async (
    val,
    id,
    responseGroupId,
    dragIndex,
    parentId
  ) => {
    console.log(val);

    if (val == "Custom") {
      var list = await [...this.props.checklist.list];
      var parentIndex = await list.findIndex((x) => x.id == parentId);
      if (parentIndex != -1) {
        var responseLibrary = await this.props.responseLibrary.find(
          (y) => y.id == responseGroupId
        );

        var indx = await list[parentIndex].conditionalList.findIndex(
          (x) => x.id == id
        );
        list[parentIndex].conditionalList[indx].dataType = await val;
        list[parentIndex].conditionalList[
          indx
        ].responseLibrary = await responseLibrary;
        if (list[parentIndex].conditionalList[indx].status != "New")
          list[parentIndex].conditionalList[indx].status = "changed";

        await this.props.onUpdateChecklist(
          list,
          this.state.template,
          this.state.section.id,
          parentIndex,
          "Change List Option"
        );
        await this.setState({
          items: list,
          canchorEl: null,
          copen: false,
          conditionIndex: dragIndex,
        });
      }
    } else {
      var list = await [...this.props.checklist.list];
      var parentIndex = await list.findIndex((x) => x.id == parentId);

      if (parentIndex != -1) {
        var indx = await list[parentIndex].conditionalList.findIndex(
          (x) => x.id == id
        );
        //alert(parentId)

        //list[indx].dataType=await val
        //await this.props.onUpdateChecklist(list,this.state.template,this.state.section.id,indx,'Change List Option')
        //alert(JSON.stringify(list[parentIndex]))
        //return
        var indx = await list[parentIndex].conditionalList.findIndex(
          (x) => x.id == id
        );
        list[parentIndex].conditionalList[indx].dataType = await val;
        list[parentIndex].conditionalList[indx].responseLibrary = [];
        if (list[parentIndex].conditionalList[indx].status != "New")
          list[parentIndex].conditionalList[indx].status = "changed";
        await this.props.onUpdateChecklist(
          list,
          this.state.template,
          this.state.section.id,
          parentIndex,
          "Change List Option"
        );
        await this.setState({ items: list, canchorEl: null, copen: false });
      }
    }
  };

  handleSubClick = (event, item, index, parentId) => {
    //alert(parentId);
    this.setState({
      sanchorEl: event.currentTarget,
      sopen: true,
      sselectedItemId: item,
      sselectedParentId: parentId,
    });
  };
  handleSubClose = async (index) => {
    console.log(index, "POPOPOPOPOP");
    await this.setState({
      sanchorEl: null,
      sopen: false,
      sselectedItemId: -1,
      sselectedParentId: -1,
    });
    await this.setState({ subElementIndex: index });
  };

  handleSubChange = async (
    val,
    id,
    responseGroupId,
    dragIndex,
    parentId,
    parentId2
  ) => {
    console.log(val);

    if (val == "Custom") {
      var list = await [...this.props.checklist.list];
    

      
      var parentIndex = await list.findIndex((x) => (x.id == parentId2) || (x.id == parentId));

      if (parentIndex != -1) {

        var responseLibrary = await this.props.responseLibrary.find(
          (y) => y.id == responseGroupId
        );

        var indx = list[parentIndex].subQuestionList.findIndex(
          (x) => x.id == id
        );
     

        list[parentIndex].subQuestionList[indx].dataType = val;
        list[parentIndex].subQuestionList[indx].responseLibrary = responseLibrary;
        if (list[parentIndex].subQuestionList[indx].status != "New")
          list[parentIndex].subQuestionList[indx].status = "changed";
 
        await this.props.onUpdateChecklist(
          list,
          this.state.template,
          this.state.section.id,
          parentIndex,
          "Change List Option"
        );
    
        await this.setState({
          items: list,
          sanchorEl: null,
          sopen: false,
          conditionIndex: dragIndex,
        });
      }
    } else {
    

      var list = await [...this.props.checklist.list];
      var parentIndex = await list.findIndex((x) => x.id == parentId2);

  

      if (parentIndex != -1) {
        var indx = await list[parentIndex].subQuestionList.findIndex(
          (x) => x.id == id
        );

        if (indx != -1) {
          list[parentIndex].subQuestionList[indx].dataType = val;
          list[parentIndex].subQuestionList[indx].responseLibrary = [];

   

          if (list[parentIndex].subQuestionList[indx].status != "New")
            list[parentIndex].subQuestionList[indx].status = "changed";
          await this.props.onUpdateChecklist(
            list,
            this.state.template,
            this.state.section.id,
            parentIndex,
            "Change List Option"
          );
          await this.setState({
            items: list,
            sanchorEl: null,
            sopen: false,
          });
        }
      }
    }
  };

  handleConditionalTextChange = (event, item, parentId) => {
    // alert(item)
    var list = [...this.props.checklist.list];
    var parentIndex = list.findIndex((x) => x.id == parentId);
    if (parentIndex != -1) {
      var indx = list[parentIndex].conditionalList.findIndex(
        (x) => x.id == item
      );
      list[parentIndex].conditionalList[indx].title = event.target.value;
      if (list[parentIndex].conditionalList[indx].status != "New")
        list[parentIndex].conditionalList[indx].status = "changed";
      this.props.onUpdateChecklist(
        list,
        this.state.template,
        event.target.value,
        parentIndex,
        "Change Field Name"
      );
      this.setState({ items: list });
    }
  };

  handleSubTextChange = (event, item, parentId) => {
    // alert(item)
    var list = [...this.props.checklist.list];
    var parentIndex = list.findIndex((x) => x.id == parentId);
    if (parentIndex != -1) {
      var indx = list[parentIndex].subQuestionList.findIndex(
        (x) => x.id == item
      );
      list[parentIndex].subQuestionList[indx].title = event.target.value;
      if (list[parentIndex].subQuestionList[indx].status != "New")
        list[parentIndex].subQuestionList[indx].status = "changed";
      this.props.onUpdateChecklist(
        list,
        this.state.template,
        event.target.value,
        parentIndex,
        "Change Field Name"
      );
      this.setState({ items: list });
    }
  };

  handleConditionalCriteriaChange = (
    parentId,
    condition,
    conditionValue,
    itemIndex
  ) => {
    // alert("ParentID: "+parentId+" Condition:"+condition+" ConditionValue:"+conditionValue)
    var list = [...this.props.checklist.list];
    var index = list.findIndex((x) => x.id == parentId);
    if (index != -1) {
      list[index].condition = condition;
      list[index].conditionValue = conditionValue;
      this.props.onUpdateChecklist(
        list,
        this.state.template,
        -1,
        itemIndex,
        "Change Field Name"
      );
      this.setState({ items: list });
    }
  };

  onDragEnd2(result, checklist, checklistIndex) {
    //alert(JSON.stringify(checklist))
    //return
    if (!result.destination) {
      return;
    }

    const items = reorder(
      checklist[checklistIndex].conditionalList,
      result.source.index,
      result.destination.index
    );
    checklist[checklistIndex].conditionalList = items;
    checklist[checklistIndex].conditionalList.map((item, index) => {
      item.position = index + 1;
      item.status = "changed";
    });
    this.setState({
      checklist,
      conditionalElementIndex: result.destination.index,
    });
    this.props.onUpdateChecklist(
      checklist,
      this.state.template,
      result.source.index,
      result.destination.index,
      "Change List Position"
    );
  }

  onDragEnd3(result, checklist, checklistIndex) {
    //alert(JSON.stringify(checklist))
    //return
    if (!result.destination) {
      return;
    }

    const items = reorder(
      checklist[checklistIndex].subQuestionList,
      result.source.index,
      result.destination.index
    );
    checklist[checklistIndex].subQuestionList = items;
    checklist[checklistIndex].subQuestionList.map((item, index) => {
      item.position = index + 1;
      item.status = "changed";
    });
    this.setState({
      checklist,
      subElementIndex: result.destination.index,
    });
    this.props.onUpdateChecklist(
      checklist,
      this.state.template,
      result.source.index,
      result.destination.index,
      "Change List Position"
    );
  }

  toggleButton = (item) => {
    var list = [...this.props.checklist.list];
    var indx = list.findIndex((x) => x.id == item.id);
    if (indx != -1) {
      list[indx].isopen = list[indx].isopen == "yes" ? "no" : "yes";
      this.props.onUpdateChecklist(
        list,
        this.state.template,
        item.title,
        indx,
        "Change Field Name"
      );
      this.setState({ items: list });
    }
  };

  toggleButton2 = (item) => {
    var list = [...this.props.checklist.list];
    var indx = list.findIndex((x) => x.id == item.id);
    if (indx != -1) {
      list[indx].isopenSub = list[indx].isopenSub == "yes" ? "no" : "yes";
      this.props.onUpdateChecklist(
        list,
        this.state.template,
        item.title,
        indx,
        "Change Field Name"
      );
      this.setState({ items: list });
    }
  };
  handleMandatoryCheck = (item) => {
    var list = [...this.props.checklist.list];
    var indx = list.findIndex((x) => x.id == item.id);
    if (indx != -1) {
      list[indx].mandatory = list[indx].mandatory == true ? false : true;
      this.props.onUpdateChecklist(
        list,
        this.state.template,
        item.title,
        indx,
        "Change Field Name"
      );
      this.setState({ items: list });
    }
  };

  handleDelete = (item) => {
    var list = [...this.props.checklist.list];
    var indx = list.findIndex((x) => x.id == item.id);
    if (indx != -1) {
      list[indx].status = "deleted";
      console.log(list[indx].status, this.state.template);
      this.props.onUpdateChecklist(
        list,
        this.state.template,
        item.title,
        indx,
        "Delete"
      );
      this.setState({ items: list });
    }
  };

  handleMultiCheck = (item) => {
    var list = [...this.props.checklist.list];
    var indx = list.findIndex((x) => x.id == item.id);
    if (indx != -1) {
      list[indx].multiselection =
        list[indx].multiselection == true ? false : true;
      this.props.onUpdateChecklist(
        list,
        this.state.template,
        item.title,
        indx,
        "Change Field Name"
      );
      this.setState({ items: list });
    }
  };

  editItem = (index) => {
    this.setState({
      selectedDragElementIndex: index,
    });
  };

  render() {
    // console.log("rerender", this.props.checklist.list);
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <ManageResponse
          responseAction={this.state.responseAction}
          openResponse={this.clickResponse}
          action={this.state.action}
          responseId={this.state.responseId}
          templateId={this.props.template_id}
          refreshResponse={this.refreshResponse}
          getResponseLibrary={this.props.getResponseLibrary}
        />
        <DragDropContext onDragEnd={this.onDragEnd} className="drag">
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <RootRef rootRef={provided.innerRef}>
                <ClickAwayListener onClickAway={this.handleClickAway}>
                  <List style={getListStyle(snapshot.isDraggingOver)}>
                    {this.props?.checklist?.list
                      .filter((v) => v.status !== "deleted")
                      .map((item, index) => {
                        console.log(
                          item.is_subquestion == "yes",
                          item.subQuestionList,
                          "{}{}{}{}{}"
                        );
                        let imuItem = Map(item);
                        // console.log(imuItem.toObject())
                        return (
                          <div
                            style={{
                              border: "2px solid #eaf7fe",
                              marginBottom: "5px",
                            }}
                          >
                            <Draggable
                              key={item.id}
                              draggableId={item.id}
                              index={index}
                              isDragDisabled={
                                item.isopen == "yes" ? true : false
                              }
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style
                                  )}
                                  onDoubleClick={() => this.editItem(index)}
                                  className={
                                    this.state.selectedDragElementIndex == index
                                      ? classes.selectedStyle
                                      : classes.unselectedStyle
                                  }
                                >
                                  <CheckComponent
                                    index={index}
                                    item={imuItem.toObject()}
                                    editItem={this.editItem}
                                    classes={classes}
                                    selectedDragElementIndex={
                                      this.state.selectedDragElementIndex
                                    }
                                    unSelect={() =>
                                      this.setState({
                                        selectedDragElementIndex: null,
                                      })
                                    }
                                    open={this.state.open}
                                    selectedItemId={this.state.selectedItemId}
                                    templateId={this.props.section.id}
                                    anchorEl={this.state.anchorEl}
                                    addNewQuestion={this.addNewQuestion}
                                    handleClick={this.handleClick}
                                    handleClose={this.handleClose}
                                    handleClickAway={this.handleClickAway}
                                    handleChange={this.handleChange}
                                    clickResponse={this.clickResponse}
                                    refreshResponse={this.refreshResponse}
                                    setReponseInfo={this.setReponseInfo}
                                    close={this.close}
                                    handleTextChange={this.handleTextChange}
                                    handleMandatoryCheck={
                                      this.handleMandatoryCheck
                                    }
                                    handleDelete={this.handleDelete}
                                    toggleButton={this.toggleButton}
                                    toggleButton2={this.toggleButton2}
                                    handleMultiCheck={this.handleMultiCheck}
                                    responseLibrary={this.props.responseLibrary}
                                  />
                                </div>
                              )}
                            </Draggable>

                            {item.is_subquestion == "yes" ? (
                              <div
                                style={{
                                  border: "1px solid #f2f2f2",
                                  margin: "5px",
                                  borderRadius: "5px",
                                }}
                              >
                                {item.isopenSub == "yes" ? (
                                  <div
                                    style={{
                                      background: "#eaf7fe",
                                      padding: "5px",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <ListItemIcon
                                      style={{}}
                                      onClick={() => {
                                        this.toggleButton2(item);
                                      }}
                                    >
                                      <ArrowOpen
                                        style={{
                                          color: "#043077",
                                          fontSize: 25,
                                          marginLeft: 0,
                                          cursor: "pointer",
                                        }}
                                      />
                                    </ListItemIcon>
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        color: "#043077",
                                        margin: 0,
                                      }}
                                    >
                                      Sub Questions
                                    </p>
                                  </div>
                                ) : item.isopenSub == "no" ? (
                                  <div
                                    style={{
                                      background: "#eaf7fe",
                                      padding: "5px",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <ListItemIcon
                                      style={{}}
                                      onClick={() => {
                                        this.toggleButton2(item);
                                      }}
                                    >
                                      <ArrowClose
                                        style={
                                          {
                                            color: "#043077",
                                            fontSize: 25,
                                            cursor: "pointer",
                                          } // marginLeft: -35,
                                        }
                                      />
                                    </ListItemIcon>
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        color: "#043077",
                                        margin: 0,
                                      }}
                                    >
                                      Sub Questions
                                    </p>
                                  </div>
                                ) : (
                                  <div />
                                )}
                                <div
                                  className={
                                    item.isopenSub == "yes"
                                      ? classes.show
                                      : classes.hide
                                  }
                                >
                                  {
                                    <div>
                                      {
                                        <DragDropContext
                                          onDragEnd={(result) => {
                                            this.onDragEnd3(
                                              result,
                                              this.state.items,
                                              index
                                            );
                                          }}
                                          className="drag"
                                        >
                                          <Droppable droppableId="droppable">
                                            {(provided3, snapshot3) => (
                                              <RootRef
                                                rootRef={provided3.innerRef}
                                              >
                                                {/* <ClickAwayListener onClickAway={this.handleClickAway}> */}
                                                <List
                                                  style={{ padding: 0 }}
                                                  // style={getListStyle(
                                                  //   snapshot2.isDraggingOver
                                                  // )}
                                                >
                                                  {item.subQuestionList.map(
                                                    (c, subIndex) => {
                                                      console.log("OOOOOOO", c);
                                                      if (c.status == "deleted")
                                                        return;
                                                      var parentId = item.id;

                                                      return (
                                                        <div
                                                          className={
                                                            item.isopenSub ==
                                                            "yes"
                                                              ? classes.show
                                                              : classes.hide
                                                          }
                                                          style={{
                                                            marginLeft: 20,
                                                            borderBotom:
                                                              "1px solid #dadada",
                                                          }}
                                                        >
                                                          <Draggable
                                                            key={c.id}
                                                            draggableId={c.id}
                                                            index={subIndex}
                                                          >
                                                            {(
                                                              provided3,
                                                              snapshot3
                                                            ) => (
                                                              <div
                                                                ref={
                                                                  provided3.innerRef
                                                                }
                                                                {...provided3.draggableProps}
                                                                {...provided3.dragHandleProps}
                                                                style={getItemStyle(
                                                                  snapshot3.isDragging,
                                                                  provided3
                                                                    .draggableProps
                                                                    .style
                                                                )}
                                                                //style={{display: "flex",justifyContent: "space-around",width:'90%',marginLeft:'10%'}}
                                                                onDoubleClick={() => {
                                                                  this.setState(
                                                                    {
                                                                      subElementIndex: subIndex,
                                                                    }
                                                                  );
                                                                }}
                                                              >
                                                                <Grid
                                                                  container
                                                                  style={{
                                                                    borderTop:
                                                                      "1px solid",
                                                                    borderColor:
                                                                      "#dadada",
                                                                    // marginLeft: 40
                                                                  }}
                                                                >
                                                                  {/* <Grid item xs={1} md={1}/> */}
                                                                  <Grid
                                                                    item
                                                                    xs={12}
                                                                    md={8}
                                                                  >
                                                                    <ListItem
                                                                      style={{
                                                                        display:
                                                                          "flex",
                                                                        alignItems:
                                                                          "center",
                                                                        padding:
                                                                          "5px 0px",
                                                                      }}
                                                                    >
                                                                      <Grid
                                                                        container
                                                                        style={{
                                                                          display:
                                                                            "flex",
                                                                          alignItems:
                                                                            "center",
                                                                        }}
                                                                      >
                                                                        <Grid
                                                                          item
                                                                        >
                                                                          <ListItemIcon>
                                                                            <DragIndicatorRoundedIcon
                                                                              style={{
                                                                                fontSize:
                                                                                  "16px",
                                                                              }}
                                                                            />{" "}
                                                                          </ListItemIcon>
                                                                        </Grid>

                                                                        <Grid
                                                                          item
                                                                        >
                                                                          <div
                                                                            className={
                                                                              this
                                                                                .state
                                                                                .subElementIndex ==
                                                                              subIndex
                                                                                ? classes.hide
                                                                                : classes.show
                                                                            }
                                                                          >
                                                                            <ListItemText
                                                                              className="checklistText2"
                                                                              style={{
                                                                                fontSize:
                                                                                  "10px",
                                                                              }}
                                                                              primary={
                                                                                c.title
                                                                              }
                                                                            />
                                                                            {/* <ListItemText
                                                                            style={{
                                                                              fontFamily:
                                                                                "ProductSans",
                                                                            }}
                                                                            primary={
                                                                              c.title
                                                                            }
                                                                            //primary={item.id}
                                                                            //secondary={c.id}
                                                                          /> */}
                                                                          </div>
                                                                          <div
                                                                            className={
                                                                              this
                                                                                .state
                                                                                .subElementIndex ==
                                                                              subIndex
                                                                                ? classes.show
                                                                                : classes.hide
                                                                            }
                                                                          >
                                                                            <TextField
                                                                              size="small"
                                                                              id={
                                                                                c.id
                                                                              }
                                                                              fullWidth
                                                                              className={[
                                                                                "customField",
                                                                                {
                                                                                  className:
                                                                                    classes.textBoxStyle,
                                                                                },
                                                                              ]}
                                                                              InputProps={{
                                                                                className:
                                                                                  classes.textBoxStyle,
                                                                              }}
                                                                              onChange={(
                                                                                e,
                                                                                id
                                                                              ) => {
                                                                                this.handleSubTextChange(
                                                                                  e,
                                                                                  c.id,
                                                                                  item.id
                                                                                );
                                                                              }}
                                                                              value={
                                                                                c.title
                                                                              }
                                                                              variant="outlined"
                                                                            />
                                                                          </div>
                                                                        </Grid>
                                                                        <Grid
                                                                          item
                                                                          className={
                                                                            this
                                                                              .state
                                                                              .subElementIndex ==
                                                                            subIndex
                                                                              ? classes.show
                                                                              : classes.hide
                                                                          }
                                                                        >
                                                                          <Tooltip title="Done">
                                                                            <IconButton
                                                                              aria-label="toggle password visibility"
                                                                              onClick={
                                                                                this
                                                                                  .handleClickAway
                                                                              }
                                                                            >
                                                                              <CheckCircleOutlineIcon
                                                                                style={{
                                                                                  color:
                                                                                    Colors.globalColor8,
                                                                                }}
                                                                              />
                                                                            </IconButton>
                                                                          </Tooltip>
                                                                        </Grid>
                                                                      </Grid>
                                                                      {/* {window.innerWidth >=
                                                                      960 && (
                                                                      <Options
                                                                        checkListItemId={
                                                                          c.id
                                                                        }
                                                                        templateId={
                                                                          item.id
                                                                        }
                                                                        controlIndex={
                                                                          conditionIndex
                                                                        }
                                                                        dragIndex={
                                                                            this
                                                                            .state
                                                                            .conditionalElementIndex
                                                                        }
                                                                        addNewQuestion={
                                                                          this
                                                                            .addNewQuestion
                                                                        }
                                                                        componentType={
                                                                          "conditional"
                                                                        }
                                                                      />
                                                                    )} */}
                                                                    </ListItem>
                                                                  </Grid>

                                                                  <Grid
                                                                    item
                                                                    className="conditionalBox"
                                                                    xs={12}
                                                                    md={4}
                                                                    style={{
                                                                      textAlign:
                                                                        "right",
                                                                      display:
                                                                        "flex",
                                                                      justifyContent:
                                                                        "flex-end",
                                                                      alignItems:
                                                                        "center",
                                                                    }}
                                                                  >
                                                                    <div
                                                                      className={
                                                                        classes.conditionalControlStyle
                                                                      }
                                                                    >
                                                                      <div
                                                                        className={
                                                                          classes.root
                                                                        }
                                                                      >
                                                                        <div
                                                                          style={{
                                                                            justifyContent:
                                                                              "flex-end",
                                                                          }}
                                                                          onClick={(
                                                                            e,
                                                                            id
                                                                          ) => {
                                                                            this.handleSubClick(
                                                                              e,
                                                                              c.id,
                                                                              index,
                                                                              item.id
                                                                            );
                                                                          }}
                                                                        >
                                                                          <DisplayControl
                                                                            selectedControl={
                                                                              c.dataType
                                                                            }
                                                                            responseLibrary={
                                                                              c.responseLibrary
                                                                            }
                                                                          />
                                                                        </div>
                                                                        <Tooltip title="Delete Sub Question">
                                                                          <IconButton
                                                                            aria-label="toggle password visibility"
                                                                            onClick={() => {
                                                                              this.props.deleteSubQuestion(
                                                                                item,
                                                                                index,
                                                                                c.id
                                                                              );
                                                                            }}
                                                                          >
                                                                            <DeleteSweepIcon
                                                                              style={{
                                                                                color:
                                                                                  Colors.globalColor8,
                                                                                fontSize: 20,
                                                                              }}
                                                                            />
                                                                          </IconButton>
                                                                        </Tooltip>
                                                                      </div>

                                                                      {window.innerWidth <=
                                                                      960 ? (
                                                                        <Dialog
                                                                          fullScreen
                                                                          open={
                                                                            this
                                                                              .state
                                                                              .copen
                                                                          }
                                                                          onClose={() => {
                                                                            this.handleSubClose(
                                                                              this
                                                                                .state
                                                                                .subElementIndex
                                                                            );
                                                                          }}
                                                                          TransitionComponent={
                                                                            Transition
                                                                          }
                                                                        >
                                                                          <AppBar
                                                                            className={
                                                                              classes.appBar
                                                                            }
                                                                          >
                                                                            <Toolbar>
                                                                              <DarkButton
                                                                                autoFocus
                                                                                color="inherit"
                                                                                onClick={() => {
                                                                                  this.handleSubClose(
                                                                                    this
                                                                                      .state
                                                                                      .subElementIndex
                                                                                  );
                                                                                }}
                                                                              >
                                                                                Close
                                                                              </DarkButton>
                                                                            </Toolbar>
                                                                          </AppBar>
                                                                          <br />
                                                                          <br />
                                                                          <br />
                                                                          <br />
                                                                          <div>
                                                                            <ContitionalResponse
                                                                              props={
                                                                                this
                                                                                  .state
                                                                              }
                                                                              close={
                                                                                this
                                                                                  .handleSubChange
                                                                              }
                                                                              openResponse={
                                                                                this
                                                                                  .clickResponse
                                                                              }
                                                                              refreshResponse={
                                                                                this
                                                                                  .refreshResponse
                                                                              }
                                                                              setReponseInfo={
                                                                                this
                                                                                  .setReponseInfo
                                                                              }
                                                                              item={
                                                                                this
                                                                                  .state
                                                                                  .sselectedItemId
                                                                              }
                                                                              parentId={
                                                                                parentId
                                                                              }
                                                                              responseLibrary={
                                                                                this
                                                                                  .props
                                                                                  .responseLibrary
                                                                              }
                                                                              DragIndex={
                                                                                this
                                                                                  .state
                                                                                  .subElementIndex
                                                                              }
                                                                              mobile={
                                                                                true
                                                                              }
                                                                            />
                                                                          </div>
                                                                        </Dialog>
                                                                      ) : (
                                                                        <Popover
                                                                          style={{
                                                                            zIndex: 5001,
                                                                          }}
                                                                          id={
                                                                            this
                                                                              .state
                                                                              .sopen
                                                                              ? "simple-popover"
                                                                              : undefined
                                                                          }
                                                                          open={
                                                                            this
                                                                              .state
                                                                              .sopen
                                                                          }
                                                                          anchorEl={
                                                                            this
                                                                              .state
                                                                              .sanchorEl
                                                                          }
                                                                          onClose={() => {
                                                                            this.handleSubClose(
                                                                              this
                                                                                .state
                                                                                .subElementIndex
                                                                            );
                                                                          }}
                                                                          anchorOrigin={{
                                                                            vertical:
                                                                              "bottom",
                                                                            horizontal:
                                                                              "center",
                                                                          }}
                                                                          transformOrigin={{
                                                                            vertical:
                                                                              "top",
                                                                            horizontal:
                                                                              "center",
                                                                          }}
                                                                          elevation={
                                                                            5
                                                                          }
                                                                        >
                                                                          <div
                                                                            className={
                                                                              window.innerWidth >=
                                                                              960
                                                                                ? classes.optionStyle
                                                                                : classes.optionStyleFull
                                                                            }
                                                                          >
                                                                            <ContitionalResponse
                                                                              props={
                                                                                this
                                                                                  .state
                                                                              }
                                                                              close={
                                                                                this
                                                                                  .handleSubChange
                                                                              }
                                                                              openResponse={
                                                                                this
                                                                                  .clickResponse
                                                                              }
                                                                              refreshResponse={
                                                                                this
                                                                                  .refreshResponse
                                                                              }
                                                                              setReponseInfo={
                                                                                this
                                                                                  .setReponseInfo
                                                                              }
                                                                              item={
                                                                                this
                                                                                  .state
                                                                                  .sselectedItemId
                                                                              }
                                                                              parentId={
                                                                                parentId
                                                                              }
                                                                              responseLibrary={
                                                                                this
                                                                                  .props
                                                                                  .responseLibrary
                                                                              }
                                                                              DragIndex={
                                                                                this
                                                                                  .state
                                                                                  .subElementIndex
                                                                              }
                                                                            />
                                                                          </div>
                                                                        </Popover>
                                                                      )}
                                                                    </div>
                                                                  </Grid>
                                                                  {window.innerWidth <
                                                                    960 && (
                                                                    <MobileOptions
                                                                      checkListItemId={
                                                                        c.id
                                                                      }
                                                                      templateId={
                                                                        item.id
                                                                      }
                                                                      controlIndex={
                                                                        subIndex
                                                                      }
                                                                      dragIndex={
                                                                        this
                                                                          .state
                                                                          .subElementIndex
                                                                      }
                                                                      addNewQuestion={
                                                                        this
                                                                          .addNewQuestion
                                                                      }
                                                                      componentType={
                                                                        "conditional"
                                                                      }
                                                                    />
                                                                  )}
                                                                </Grid>
                                                              </div>
                                                              //==========================//
                                                            )}
                                                          </Draggable>
                                                        </div>
                                                      );
                                                    }
                                                  )
                                                  //=============//
                                                  }
                                                  {provided3.placeholder}
                                                  <hr
                                                    style={{
                                                      borderTop:
                                                        "1px solid #dadada",
                                                      borderBottom: "none",
                                                      marginTop: 0,
                                                      width: "100%",
                                                      marginBottom: 10,
                                                    }}
                                                  />

                                                  <Button
                                                    size="small"
                                                    className="startInspectionBtnSmall"
                                                    style={{
                                                      backgroundColor:
                                                        Colors.globalColor8,
                                                      marginLeft: 20,
                                                      marginBottom: 10,
                                                    }}
                                                    onClick={() => {
                                                      this.props.addNewSubQuestion(
                                                        item,
                                                        index,
                                                        this.props.section.id
                                                      );
                                                    }}
                                                  >
                                                    + Add Sub Question
                                                  </Button>
                                                </List>

                                                {/* </ClickAwayListener> */}
                                              </RootRef>
                                            )}
                                          </Droppable>
                                        </DragDropContext>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            ) : (
                              <div />
                            )}

                            {/* //working here */}
                            {item.conditional == "yes" ? (
                              <div
                                style={{
                                  border: "1px solid #f2f2f2",
                                  margin: "5px",
                                  borderRadius: "5px",
                                }}
                              >
                                {item.isopen == "yes" ? (
                                  <div
                                    style={{
                                      background: "#eaf7fe",
                                      padding: "5px",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <ListItemIcon
                                      style={{}}
                                      onClick={() => {
                                        this.toggleButton(item);
                                      }}
                                    >
                                      <ArrowOpen
                                        style={{
                                          color: "#043077",
                                          fontSize: 25,
                                          marginLeft: 0,
                                          cursor: "pointer",
                                        }}
                                      />
                                    </ListItemIcon>
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        color: "#043077",
                                        margin: 0,
                                      }}
                                    >
                                      Conditional Questions
                                    </p>
                                  </div>
                                ) : item.isopen == "no" ? (
                                  <div
                                    style={{
                                      background: "#eaf7fe",
                                      padding: "5px",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <ListItemIcon
                                      style={{}}
                                      onClick={() => {
                                        this.toggleButton(item);
                                      }}
                                    >
                                      <ArrowClose
                                        style={
                                          {
                                            color: "#043077",
                                            fontSize: 25,
                                            cursor: "pointer",
                                          } // marginLeft: -35,
                                        }
                                      />
                                    </ListItemIcon>
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        color: "#043077",
                                        margin: 0,
                                      }}
                                    >
                                      Conditional Questions
                                    </p>
                                  </div>
                                ) : (
                                  <div />
                                )}

                                <div
                                  className={
                                    item.isopen == "yes"
                                      ? classes.show
                                      : classes.hide
                                  }
                                >
                                  {
                                    <div>
                                      <ListItem
                                        className={classes.itemRuleStyle}
                                      >
                                        <Grid container alignItems="center">
                                          <Grid
                                            item
                                            style={{
                                              display: "flex",
                                              flexDirection: "row",
                                              alignItems: "center",
                                            }}
                                          >
                                            {item.dataType == "Text field" ? (
                                              <p className="conditionalQuestion">
                                                If answer
                                              </p>
                                            ) : item.dataType == "Number" ? (
                                              <p className="conditionalQuestion">
                                                If answer is
                                              </p>
                                            ) : item.dataType == "Checkbox" ? (
                                              <p className="conditionalQuestion">
                                                If checkbox is
                                              </p>
                                            ) : item.dataType == "Slider" ? (
                                              <p className="conditionalQuestion">
                                                If slider value
                                              </p>
                                            ) : item.dataType == "Signature" ? (
                                              <p className="conditionalQuestion">
                                                If Signature
                                              </p>
                                            ) : item.dataType == "Custom" ||
                                              item.dataType == "Global" ? (
                                              <p className="conditionalQuestion">
                                                If Answer is
                                              </p>
                                            ) : (
                                              <div />
                                            )}
                                          </Grid>
                                          <Grid item>
                                            <Logic
                                              parent={item}
                                              itemIndex={index}
                                              dataType={item.dataType}
                                              responseLibrary={
                                                item.responseLibrary
                                              }
                                              setCondition={
                                                this
                                                  .handleConditionalCriteriaChange
                                              }
                                            />
                                          </Grid>
                                        </Grid>
                                      </ListItem>
                                      {
                                        <DragDropContext
                                          onDragEnd={(result) => {
                                            this.onDragEnd2(
                                              result,
                                              this.state.items,
                                              index
                                            );
                                          }}
                                          className="drag"
                                        >
                                          <Droppable droppableId="droppable">
                                            {(provided2, snapshot2) => (
                                              <RootRef
                                                rootRef={provided2.innerRef}
                                              >
                                                {/* <ClickAwayListener onClickAway={this.handleClickAway}> */}
                                                <List
                                                  style={{ padding: 0 }}
                                                  // style={getListStyle(
                                                  //   snapshot2.isDraggingOver
                                                  // )}
                                                >
                                                  {item.conditionalList.map(
                                                    (c, conditionIndex) => {
                                                      if (c.status == "deleted")
                                                        return;
                                                      var parentId = item.id;
                                                      //alert(item.id)
                                                      return (
                                                        <div
                                                          className={
                                                            item.isopen == "yes"
                                                              ? classes.show
                                                              : classes.hide
                                                          }
                                                          style={{
                                                            marginLeft: 20,
                                                            borderBotom:
                                                              "1px solid #dadada",
                                                          }}
                                                        >
                                                          <Draggable
                                                            key={c.id}
                                                            draggableId={c.id}
                                                            index={
                                                              conditionIndex
                                                            }
                                                          >
                                                            {(
                                                              provided2,
                                                              snapshot2
                                                            ) => (
                                                              <div
                                                                ref={
                                                                  provided2.innerRef
                                                                }
                                                                {...provided2.draggableProps}
                                                                {...provided2.dragHandleProps}
                                                                style={getItemStyle(
                                                                  snapshot2.isDragging,
                                                                  provided2
                                                                    .draggableProps
                                                                    .style
                                                                )}
                                                                //style={{display: "flex",justifyContent: "space-around",width:'90%',marginLeft:'10%'}}
                                                                onDoubleClick={() => {
                                                                  this.setState(
                                                                    {
                                                                      conditionalElementIndex: conditionIndex,
                                                                    }
                                                                  );
                                                                }}
                                                              >
                                                                <Grid
                                                                  container
                                                                  style={{
                                                                    borderTop:
                                                                      "1px solid",
                                                                    borderColor:
                                                                      "#dadada",
                                                                    // marginLeft: 40
                                                                  }}
                                                                >
                                                                  {/* <Grid item xs={1} md={1}/> */}
                                                                  <Grid
                                                                    item
                                                                    xs={12}
                                                                    md={8}
                                                                  >
                                                                    <ListItem
                                                                      style={{
                                                                        display:
                                                                          "flex",
                                                                        alignItems:
                                                                          "center",
                                                                        padding:
                                                                          "5px 0px",
                                                                      }}
                                                                    >
                                                                      <Grid
                                                                        container
                                                                        style={{
                                                                          display:
                                                                            "flex",
                                                                          alignItems:
                                                                            "center",
                                                                        }}
                                                                      >
                                                                        <Grid
                                                                          item
                                                                        >
                                                                          <ListItemIcon>
                                                                            <DragIndicatorRoundedIcon
                                                                              style={{
                                                                                fontSize:
                                                                                  "16px",
                                                                              }}
                                                                            />{" "}
                                                                          </ListItemIcon>
                                                                        </Grid>

                                                                        <Grid
                                                                          item
                                                                        >
                                                                          <div
                                                                            className={
                                                                              this
                                                                                .state
                                                                                .conditionalElementIndex ==
                                                                              conditionIndex
                                                                                ? classes.hide
                                                                                : classes.show
                                                                            }
                                                                          >
                                                                            <ListItemText
                                                                              className="checklistText2"
                                                                              style={{
                                                                                fontSize:
                                                                                  "10px",
                                                                              }}
                                                                              primary={
                                                                                c.title
                                                                              }
                                                                            />
                                                                          </div>
                                                                          <div
                                                                            className={
                                                                              this
                                                                                .state
                                                                                .conditionalElementIndex ==
                                                                              conditionIndex
                                                                                ? classes.show
                                                                                : classes.hide
                                                                            }
                                                                          >
                                                                            <TextField
                                                                              size="small"
                                                                              id={
                                                                                c.id
                                                                              }
                                                                              fullWidth
                                                                              className={[
                                                                                "customField",
                                                                                {
                                                                                  className:
                                                                                    classes.textBoxStyle,
                                                                                },
                                                                              ]}
                                                                              InputProps={{
                                                                                className:
                                                                                  classes.textBoxStyle,
                                                                              }}
                                                                              onChange={(
                                                                                e,
                                                                                id
                                                                              ) => {
                                                                                this.handleConditionalTextChange(
                                                                                  e,
                                                                                  c.id,
                                                                                  item.id
                                                                                );
                                                                              }}
                                                                              value={
                                                                                c.title
                                                                              }
                                                                              variant="outlined"
                                                                            />
                                                                          </div>
                                                                        </Grid>
                                                                        <Grid
                                                                          item
                                                                          className={
                                                                            this
                                                                              .state
                                                                              .conditionalElementIndex ==
                                                                            conditionIndex
                                                                              ? classes.show
                                                                              : classes.hide
                                                                          }
                                                                        >
                                                                          <Tooltip title="Done">
                                                                            <IconButton
                                                                              aria-label="toggle password visibility"
                                                                              onClick={
                                                                                this
                                                                                  .handleClickAway
                                                                              }
                                                                            >
                                                                              <CheckCircleOutlineIcon
                                                                                style={{
                                                                                  color:
                                                                                    Colors.globalColor8,
                                                                                }}
                                                                              />
                                                                            </IconButton>
                                                                          </Tooltip>
                                                                        </Grid>
                                                                      </Grid>
                                                                    </ListItem>
                                                                  </Grid>

                                                                  <Grid
                                                                    item
                                                                    className="conditionalBox"
                                                                    xs={12}
                                                                    md={4}
                                                                    style={{
                                                                      textAlign:
                                                                        "right",
                                                                      display:
                                                                        "flex",
                                                                      justifyContent:
                                                                        "flex-end",
                                                                      alignItems:
                                                                        "center",
                                                                    }}
                                                                  >
                                                                    <div
                                                                      className={
                                                                        classes.conditionalControlStyle
                                                                      }
                                                                    >
                                                                      <div
                                                                        className={
                                                                          classes.root
                                                                        }
                                                                      >
                                                                        <div
                                                                          style={{
                                                                            justifyContent:
                                                                              "flex-end",
                                                                          }}
                                                                          onClick={(
                                                                            e,
                                                                            id
                                                                          ) => {
                                                                            this.handleConditionalClick(
                                                                              e,
                                                                              c.id,
                                                                              index,
                                                                              item.id
                                                                            );
                                                                          }}
                                                                        >
                                                                          <DisplayControl
                                                                            selectedControl={
                                                                              c.dataType
                                                                            }
                                                                            responseLibrary={
                                                                              c.responseLibrary
                                                                            }
                                                                          />
                                                                        </div>
                                                                        <Tooltip title="Delete Conditional Question">
                                                                          <IconButton
                                                                            aria-label="toggle password visibility"
                                                                            onClick={() => {
                                                                              this.props.deleteCondition(
                                                                                item,
                                                                                index,
                                                                                c.id
                                                                              );
                                                                            }}
                                                                          >
                                                                            <DeleteSweepIcon
                                                                              style={{
                                                                                color:
                                                                                  Colors.globalColor8,
                                                                                fontSize: 20,
                                                                              }}
                                                                            />
                                                                          </IconButton>
                                                                        </Tooltip>
                                                                      </div>

                                                                      {window.innerWidth <=
                                                                      960 ? (
                                                                        <Dialog
                                                                          fullScreen
                                                                          open={
                                                                            this
                                                                              .state
                                                                              .copen
                                                                          }
                                                                          onClose={() => {
                                                                            this.handleConditionalClose(
                                                                              this
                                                                                .state
                                                                                .conditionalElementIndex
                                                                            );
                                                                          }}
                                                                          TransitionComponent={
                                                                            Transition
                                                                          }
                                                                        >
                                                                          <AppBar
                                                                            className={
                                                                              classes.appBar
                                                                            }
                                                                          >
                                                                            <Toolbar>
                                                                              <DarkButton
                                                                                autoFocus
                                                                                color="inherit"
                                                                                onClick={() => {
                                                                                  this.handleConditionalClose(
                                                                                    this
                                                                                      .state
                                                                                      .conditionalElementIndex
                                                                                  );
                                                                                }}
                                                                              >
                                                                                Close
                                                                              </DarkButton>
                                                                            </Toolbar>
                                                                          </AppBar>
                                                                          <br />
                                                                          <br />
                                                                          <br />
                                                                          <br />
                                                                          <div
                                                                          // className={
                                                                          // window.innerWidth <=
                                                                          // 960
                                                                          //   ? classes.optionStyle
                                                                          //   : classes.optionStyleFull
                                                                          // }
                                                                          >
                                                                            <ContitionalResponse
                                                                              props={
                                                                                this
                                                                                  .state
                                                                              }
                                                                              close={
                                                                                this
                                                                                  .handleConditionalChange
                                                                              }
                                                                              openResponse={
                                                                                this
                                                                                  .clickResponse
                                                                              }
                                                                              refreshResponse={
                                                                                this
                                                                                  .refreshResponse
                                                                              }
                                                                              setReponseInfo={
                                                                                this
                                                                                  .setReponseInfo
                                                                              }
                                                                              item={
                                                                                this
                                                                                  .state
                                                                                  .cselectedItemId
                                                                              }
                                                                              parentId={
                                                                                parentId
                                                                              }
                                                                              responseLibrary={
                                                                                this
                                                                                  .props
                                                                                  .responseLibrary
                                                                              }
                                                                              DragIndex={
                                                                                this
                                                                                  .state
                                                                                  .conditionalElementIndex
                                                                              }
                                                                              mobile={
                                                                                true
                                                                              }
                                                                            />
                                                                          </div>
                                                                        </Dialog>
                                                                      ) : (
                                                                        <Popover
                                                                          style={{
                                                                            zIndex: 5001,
                                                                          }}
                                                                          id={
                                                                            this
                                                                              .state
                                                                              .copen
                                                                              ? "simple-popover"
                                                                              : undefined
                                                                          }
                                                                          open={
                                                                            this
                                                                              .state
                                                                              .copen
                                                                          }
                                                                          anchorEl={
                                                                            this
                                                                              .state
                                                                              .canchorEl
                                                                          }
                                                                          onClose={() => {
                                                                            this.handleConditionalClose(
                                                                              this
                                                                                .state
                                                                                .conditionalElementIndex
                                                                            );
                                                                          }}
                                                                          anchorOrigin={{
                                                                            vertical:
                                                                              "bottom",
                                                                            horizontal:
                                                                              "center",
                                                                          }}
                                                                          transformOrigin={{
                                                                            vertical:
                                                                              "top",
                                                                            horizontal:
                                                                              "center",
                                                                          }}
                                                                          elevation={
                                                                            5
                                                                          }
                                                                        >
                                                                          <div
                                                                            className={
                                                                              window.innerWidth >=
                                                                              960
                                                                                ? classes.optionStyle
                                                                                : classes.optionStyleFull
                                                                            }
                                                                          >
                                                                            <ContitionalResponse
                                                                              props={
                                                                                this
                                                                                  .state
                                                                              }
                                                                              close={
                                                                                this
                                                                                  .handleConditionalChange
                                                                              }
                                                                              openResponse={
                                                                                this
                                                                                  .clickResponse
                                                                              }
                                                                              refreshResponse={
                                                                                this
                                                                                  .refreshResponse
                                                                              }
                                                                              setReponseInfo={
                                                                                this
                                                                                  .setReponseInfo
                                                                              }
                                                                              item={
                                                                                this
                                                                                  .state
                                                                                  .cselectedItemId
                                                                              }
                                                                              parentId={
                                                                                parentId
                                                                              }
                                                                              responseLibrary={
                                                                                this
                                                                                  .props
                                                                                  .responseLibrary
                                                                              }
                                                                              DragIndex={
                                                                                this
                                                                                  .state
                                                                                  .conditionalElementIndex
                                                                              }
                                                                            />
                                                                          </div>
                                                                        </Popover>
                                                                      )}
                                                                    </div>
                                                                  </Grid>
                                                                  {window.innerWidth <
                                                                    960 && (
                                                                    <MobileOptions
                                                                      checkListItemId={
                                                                        c.id
                                                                      }
                                                                      templateId={
                                                                        item.id
                                                                      }
                                                                      controlIndex={
                                                                        conditionIndex
                                                                      }
                                                                      dragIndex={
                                                                        this
                                                                          .state
                                                                          .conditionalElementIndex
                                                                      }
                                                                      addNewQuestion={
                                                                        this
                                                                          .addNewQuestion
                                                                      }
                                                                      componentType={
                                                                        "conditional"
                                                                      }
                                                                    />
                                                                  )}
                                                                </Grid>
                                                              </div>
                                                              //==========================//
                                                            )}
                                                          </Draggable>
                                                        </div>
                                                      );
                                                    }
                                                  )
                                                  //=============//
                                                  }
                                                  {provided2.placeholder}
                                                  <hr
                                                    style={{
                                                      borderTop:
                                                        "1px solid #dadada",
                                                      borderBottom: "none",
                                                      marginTop: 0,
                                                      width: "100%",
                                                      marginBottom: 10,
                                                    }}
                                                  />

                                                  <Button
                                                    size="small"
                                                    className="startInspectionBtnSmall"
                                                    style={{
                                                      backgroundColor:
                                                        Colors.globalColor8,
                                                      marginLeft: 20,
                                                      marginBottom: 10,
                                                    }}
                                                    onClick={() => {
                                                      this.props.addNewCondition(
                                                        item,
                                                        index,
                                                        this.props.section.id
                                                      );
                                                    }}
                                                  >
                                                    + Add Conditional Question
                                                  </Button>
                                                </List>

                                                {/* </ClickAwayListener> */}
                                              </RootRef>
                                            )}
                                          </Droppable>
                                        </DragDropContext>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            ) : (
                              <div />
                            )}

                            {/* SUB Questiopns */}
                          </div>
                        );
                      })}
                    {provided.placeholder}
                  </List>
                </ClickAwayListener>
              </RootRef>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    );
  }
}

export default withStyles(useStyles)(drag);
